export const uploadConstants = {
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png'],
    ALLOWED_IMAGE_SIZE: 2, // in MBs
    FILE_STATUS_UPLOADING: 'uploading',
    FILE_STATUS_DONE: 'done',
    SIZE_DIVIDER: 1048576
};
